import { useMutation } from '@tanstack/react-query';

import { exportPartyToAssu } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useExportPartyToAssu() {
  return useMutation({
    mutationFn: ({ partyId }: { partyId: string }) =>
      exportPartyToAssu(
        {
          params: {
            path: { party_id: partyId },
            query: {},
          },
        },
        wgApi,
      ),
  });
}
